import FormSectionHeader from 'app/ui_v2/form-section-header/FormSectionHeader';
import { Outlet } from 'react-router';

import { Container } from '@mui/material';

import PerformanceTabs from './performance-tabs/PerformanceTabs';

export default function InspectorPerformanceSections() {
  return (
    <Container maxWidth="lg" disableGutters className="disable-center">
      <FormSectionHeader title="Metrics" subtitle="" isValid={false} />
      <PerformanceTabs />
      <Outlet />
    </Container>
  );
}
